module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin__list"
  }, [_c('div', {
    staticClass: "row mb-1 small text-muted"
  }, [_c('div', {
    staticClass: "col-1 d-none d-md-block"
  }, [_vm._v("Id")]), _vm._v(" "), _vm._t("headerList")], 2), _vm._v(" "), (_vm.loading) ? _c('loading', {
    attrs: {
      "message": "Загружаем ..."
    }
  }) : _vm._l((_vm.items), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "row mb-1 admin__list__item admin__list__item_hover-bg-gray"
    }, [_c('div', {
      staticClass: "col-1 d-none d-md-block"
    }, [_vm._v("\n      " + _vm._s(item.id) + "\n    ")]), _vm._v(" "), _vm._t("default", null, {
      item: item
    })], 2)
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-20085102", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-20085102"}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Admin/Components/AdminList.vue
// module id = 1010
// module chunks = 1